import * as globals from '@wandb/weave/common/css/globals.styles';
import {Icon, IconName} from '@wandb/weave/components/Icon';
import React from 'react';

import * as S from './AccountIcon.styles';
import {AccountType} from './util';

type AccountIconProps = {
  accountType: AccountType;
  isProfileMenu?: boolean;
  isSelectedAccount?: boolean;
};

function getProfileMenuColor(isSelectedAccount: boolean) {
  if (isSelectedAccount) {
    return globals.TEAL_550;
  }
  return globals.hexToRGB(globals.MOON_300, 0.48);
}

const AccountIconComp = ({
  accountType,
  isProfileMenu,
  isSelectedAccount = false,
}: AccountIconProps) => {
  const {iconName, iconColor} = AccountTypeToIconNameMap[accountType];

  return (
    <S.IconWrapper
      color={isProfileMenu ? getProfileMenuColor(isSelectedAccount) : iconColor}
      isProfileMenu
      isOtherAccount={isProfileMenu && !isSelectedAccount}>
      <Icon name={iconName} />
    </S.IconWrapper>
  );
};

type IconData = {
  iconName: IconName;
  iconColor: string;
};

const AccountTypeToIconNameMap: Record<AccountType, IconData> = {
  [AccountType.Personal]: {
    iconName: 'user-profile-personal',
    iconColor: globals.GREEN_550,
  },
  [AccountType.Corporate]: {
    iconName: 'organization-corporate',
    iconColor: globals.TEAL_550,
  },
  [AccountType.Academic]: {
    iconName: 'education-academic',
    iconColor: globals.warningLight,
  },
};

export const AccountIcon = React.memo(AccountIconComp);
